import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Row, Col, Panel, Image } from 'react-bootstrap';
import { loadHeadOfficeAnalyticsData } from './actions';
import Filter from './Filter';
import moment from 'moment';
import authUtils from '../../../auth/utils';
import Stats from './Stats';
import LessonPaymentsRevenue from './LessonPaymentsRevenue';
//import LessonPaymentsGrowthRate from './LessonPaymentsGrowthRate';
import LessonPaymentsCumulativeRevenue from './LessonPaymentsCumulativeRevenue';
//import LessonPaymentsByGrade from './LessonPaymentsByGrade';
import LessonPaymentsByMasterFranchisee from './LessonPaymentsByMasterFranchisee';
//import LessonPaymentsByPaymentType from './LessonPaymentsByPaymentType';
//import LessonPaymentsByPaymentMethod from './LessonPaymentsByPaymentMethod';
//import Discounts from './Discounts';
//import DiscountsByType from './DiscountsByType';
import ReferralSource from './ReferralSource';
import ChildrenByMasterFranchisee from './ChildrenByMasterFranchisee';
import { withTranslation } from 'react-i18next';
import globalize from '../../../common/services/globalize';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChartColumn } from '@fortawesome/free-solid-svg-icons';

class Home extends Component {
	constructor(props) {
		super(props);
		this.handleFilterApply = this.handleFilterApply.bind(this);

		const today = moment().startOf('date');
		this.state = {
			periodFrom: today.clone().subtract(1, 'month'),
			periodTo: today,
			term: null,
			year: null
		};
	}

	componentDidMount() {
		this.reloadData();
	}

	reloadData() {
		const { periodFrom, periodTo, term, year } = this.state;

		const statsRequestData = {
			periodFrom: periodFrom.startOf('day').format(),
			periodTo: periodTo.endOf('day').format(),
			term,
			year,
			timeZone: globalize.getCurrentTimeZone(this.props.franchisor)
		};

		const { loadHeadOfficeAnalyticsData } = this.props;
		loadHeadOfficeAnalyticsData('dashboardStats', statsRequestData);
		loadHeadOfficeAnalyticsData('lessonPaymentsRevenue', statsRequestData);
		loadHeadOfficeAnalyticsData('lessonPaymentsByCategory', statsRequestData);
		//loadHeadOfficeAnalyticsData('lessonPaymentsGrowthRate', statsRequestData);
		loadHeadOfficeAnalyticsData('lessonsByCategory', statsRequestData);
	}

	handleFilterApply(filter) {
		this.setState({ ...filter }, () => this.reloadData());
	}

	render() {
		const {
			currentUser,
			analytics: {
				dashboardStats,
				lessonPaymentsRevenue,
				lessonPaymentsByCategory = {
					loading: false, data: null
				},
				lessonsByCategory = {
					loading: false, data: null
				},
				lessonPaymentsGrowthRate
			},
			franchisor,
			termTypes,
			years,
			activeYear,
			t
		} = this.props;

		const logoImg = franchisor.logoUrl || require('../../../../theme/images/logo-kindyroo.png');

		const lessonPaymentsByPaymentType = {
			loading: lessonPaymentsByCategory.loading,
			data: lessonPaymentsByCategory.data && lessonPaymentsByCategory.data.paymentTypes
		};
		const lessonPaymentsByPaymentMethod = {
			loading: lessonPaymentsByCategory.loading,
			data: lessonPaymentsByCategory.data && lessonPaymentsByCategory.data.paymentMethods
		};

		const lessonPaymentsByGrade = {
			loading: lessonPaymentsByCategory.loading,
			data: lessonPaymentsByCategory.data && lessonPaymentsByCategory.data.grades
		};

		const discountsByType = {
			loading: lessonPaymentsByCategory.loading,
			data: lessonPaymentsByCategory.data && lessonPaymentsByCategory.data.discountTypes
		};

		const referralSourcesByType = {
			loading: lessonPaymentsByCategory.loading,
			data: lessonPaymentsByCategory.data && lessonPaymentsByCategory.data.referralSourceTypes
		};

		const lessonPaymentsByMasterFranchisee = {
			loading: lessonPaymentsByCategory.loading,
			data: lessonPaymentsByCategory.data && lessonPaymentsByCategory.data.masterFranchisees
		};

		const lessonsByMasterFranchisee = {
			loading: lessonsByCategory.loading,
			data: lessonsByCategory.data && lessonsByCategory.data.masterFranchisees
		};


		const canViewReports = authUtils.hasPermission(currentUser, 'MasterFranchisees');

		//const termsReferenceLines = Object.values(terms).map(x => ({ /*label: x.typeName,*/ value: x.startDate }));

	
		return <div>
			{!canViewReports && <div style={{ margin: '100px 0px 0px' }}><Image responsive src={logoImg} style={{ display: 'block', margin: '0 auto' }} /></div>}
			{canViewReports && <div className='dashboard'>
				<Row className='mb-1'>
					<Col xs={12}>
						<Filter currentCulture={globalize.getCurrentCulture(franchisor)}
							periodFrom={this.state.periodFrom} periodTo={this.state.periodTo}
							term={this.state.term} terms={termTypes}
							year={this.state.year} years={years} activeYear={activeYear}
							onApplyFilter={this.handleFilterApply}
						/>
					</Col>
				</Row>
				<Stats {...dashboardStats} />
				{<div>
					<Row>
						<Col sm={12} md={6}>
							<Panel>
								<Panel.Heading><FontAwesomeIcon icon={faChartColumn} />{t('SalesDashboard_SalesForPeriod')}</Panel.Heading>
								<Panel.Body>
									<LessonPaymentsRevenue {...lessonPaymentsRevenue} /*referenceLinesX={termsReferenceLines}*/ />
								</Panel.Body>
							</Panel>
						</Col>
						<Col sm={12} md={6}>
							<Panel>
								<Panel.Heading><FontAwesomeIcon icon={faChartColumn} />{t('SalesDashboard_CumulativeSalesForPeriod')}</Panel.Heading>
								<Panel.Body>
									<LessonPaymentsCumulativeRevenue {...lessonPaymentsRevenue} /*referenceLinesX={termsReferenceLines}*/ />
								</Panel.Body>
							</Panel>
						</Col>
					</Row>
					<Row>
						<Col sm={6}>
							<Panel>
								<Panel.Heading><FontAwesomeIcon icon={faChartColumn} />{t('HeadOfficeDashboard_ChildrenByMasterFranchisee')}</Panel.Heading>
								<Panel.Body>
									<ChildrenByMasterFranchisee {...lessonsByMasterFranchisee} />
								</Panel.Body>
							</Panel>
						</Col>
						<Col sm={6} md={3}>
							<Panel>
								<Panel.Heading><FontAwesomeIcon icon={faChartColumn} />{t('SalesDashboard_ReferralSources')}</Panel.Heading>
								<Panel.Body>
									<ReferralSource {...referralSourcesByType} />
								</Panel.Body>
							</Panel>
						</Col>
					</Row>
					<Row>
						<Col sm={12} md={6}>
							<Panel>
								<Panel.Heading><FontAwesomeIcon icon={faChartColumn} />{t('SalesDashboard_SalesByMasterFranchisee')}</Panel.Heading>
								<Panel.Body>
									<LessonPaymentsByMasterFranchisee {...lessonPaymentsByMasterFranchisee} />
								</Panel.Body>
							</Panel>
						</Col>
					</Row>
				</div>
				/*<Row>
					<Col sm={6} md={3}>
						<Panel>
							<Panel.Heading><FontAwesome name='bar-chart' />{t('SalesDashboard_SalesByPaymentType')}</Panel.Heading>
							<Panel.Body>
								<LessonPaymentsByPaymentType {...lessonPaymentsByPaymentType} />
							</Panel.Body>
						</Panel>
					</Col>
					<Col sm={6} md={3}>
						<Panel>
							<Panel.Heading><FontAwesome name='bar-chart' />{t('SalesDashboard_SalesByPaymentMethod')}</Panel.Heading>
							<Panel.Body>
								<LessonPaymentsByPaymentMethod {...lessonPaymentsByPaymentMethod} />
							</Panel.Body>
						</Panel>
					</Col>					
					<Col sm={12} md={6}>
						<Panel>
							<Panel.Heading><FontAwesome name='bar-chart' />{t('SalesDashboard_SalesByGrade')}</Panel.Heading>
							<Panel.Body>
								<LessonPaymentsByGrade {...lessonPaymentsByGrade} />
							</Panel.Body>
						</Panel>
					</Col>
				</Row>
				<Col sm={12} md={6}>
						<Panel>
							<Panel.Heading><FontAwesome name='bar-chart' />{t('SalesDashboard_DiscountsForPeriod')}</Panel.Heading>
							<Panel.Body>
								<Discounts {...lessonPaymentsRevenue} referenceLinesX={termsReferenceLines} />
							</Panel.Body>
						</Panel>
					</Col>
					<Col sm={6} md={3}>
						<Panel>
							<Panel.Heading><FontAwesome name='bar-chart' />{t('SalesDashboard_DiscountsByType')}</Panel.Heading>
							<Panel.Body>
								<DiscountsByType {...discountsByType} />
							</Panel.Body>
						</Panel>
					</Col>
				

				<Row>
					<Col sm={12} md={6}>
						<Panel>
							<Panel.Heading><FontAwesome name='bar-chart' />{t('SalesDashboard_GrowthRate')}</Panel.Heading>
							<Panel.Body>
								<LessonPaymentsGrowthRate {...lessonPaymentsGrowthRate} referenceLinesX={termsReferenceLines} />
							</Panel.Body>
						</Panel>
					</Col>
				</Row>
				*/}
			</div>}
		</div>;
	}
}

const mapStateToProps = (state) => {
	const {
		analytics: { headOffice },
		auth: { currentUser },
		configuration: { franchisor },
		lookups: { termTypes, years }
	} = state;
	const today = new Date();
	const activeYear = today.getFullYear();
	return {
		analytics: headOffice,
		currentUser,
		franchisor,
		termTypes,
		years,
		activeYear: activeYear,
	};
};

export default connect(mapStateToProps, {
	loadHeadOfficeAnalyticsData
})(withTranslation()(Home));